import React, { useEffect, useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { LANGUAGE_KEY } from "../Constants/mainKeys";
import NotFoundPage from "../Pages/404/notFoundPage";
import UnderMaintenancePage from "../Pages/UnderMaintenancePage/underMaintenancePage";
import _Help from "../Pages/Help/_help";
import RolesService from "../Services/rolesService";
import { useSelector } from "react-redux";
import AuthenticationByRefreshToken from "../Pages/AuthenticationByRefreshToken/AuthenticationByRefreshToken";
import MainService from "../Services/mainService";
import Students from "../MetDepartmentPages/Students";
import StudentForm from "../Pages/students/StudentForm";
import OrganizationSettings from "../MetDepartmentPages/OrganizationSettings";
import LogOut from "../Pages/LogOut/LogOut";
import DocumentsTable from "../MetDepartmentPages/Documents/DocumentsTable";
import DocumentForm from "../MetDepartmentPages/Documents/DocumentForm";
import DocumentSubscription from "../MetDepartmentPages/Documents/DocumentSubscription";
import DocumentView from "../MetDepartmentPages/Documents/DocumentView";
import ContactUs from "../UserPages/ContactUs/contactUs";
import About from "../UserPages/About/about";
import PrivacyPolicy from "../UserPages/PrivacyPolicy/privacyPolicy";
import CookiesPocicy from "../UserPages/Policy/cookiesPolicy";

const MetDepartmentRouet = () => {
	const { role } = useSelector(state => state.user);
	const [roleService, setRoleService] = useState(null);

	useEffect(() => {
		MainService.isJson(role) &&
			setRoleService(new RolesService(JSON.parse(role)));
	}, [role]);

	return roleService ? (
		<Switch>
			<Route path="/:language/student" exact component={Students} />
			<Route path="/:language/student-form" exact component={StudentForm} />
			<Route
				path="/:language/organizationSettings"
				exact
				component={OrganizationSettings}
			/>

			<Route path="/:language/contact-us" exact component={ContactUs} />
			<Route path="/:language/about/:pageId" exact component={About} />
			<Route path="/:language/privacy-policy/:pageId" exact component={PrivacyPolicy} />
			<Route path="/:language/cookies-policy/:pageId" exact component={CookiesPocicy} />

			<Route path="/:language/document" exact component={DocumentsTable} />
			<Route path="/:language/document/document-form" exact component={DocumentForm} />
			<Route path="/:language/document/document-form/:documentId" exact component={DocumentForm} />
			<Route path="/:language/document/document-view/:documentId" exact component={DocumentView} />
			<Route path="/:language/document/subscribe/:documentId" exact component={DocumentSubscription} />

			{/* <Route path="/:language/student" /> */}
			<Route path="/:language/help" exact component={_Help} />
			<Route path="/:language/help/topic/:topicId" exact component={_Help} />
			<Route path="/:language/help/faq/:faqId" exact component={_Help} />
			{/* AuthenticationByRefreshToken */}
			<Route
				path="/:language/authentication/:refreshToken"
				exact
				component={AuthenticationByRefreshToken}
			/>
			<Route path="/:language/logout" exact component={LogOut} />
			{/* 404 */}
			<Route path="/:language/not-found/404" exact component={NotFoundPage} />
			{/* Server error page */}
			<Route
				path="/:language/under-maintenance"
				exact
				component={UnderMaintenancePage}
			/>
			<Redirect to={`/${localStorage.getItem(LANGUAGE_KEY)}/student`} />
			<Route component={NotFoundPage} />
		</Switch>
	) : null;
};

export default MetDepartmentRouet;
